import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { yellow, grey, red } from '@mui/material/colors';
import { COLORS } from '@scope/scope-one-ui/theme';

const defaultTheme = createTheme();
const useReportPage = window.location.href.includes('/generate-report/');

const black = '#000000';
const white = '#FFFFFF';
const { main } = COLORS.primary;

export const theme = createTheme(
  adaptV4Theme({
    palette: {
      primary: {
        contrastText: white,
        main,
      },
      secondary: {
        contrastText: white,
        main,
      },
      background: {
        default: COLORS.background.control,
      },
      custom: {
        black,
        white,
        green: '#34A850',
        darkCyan: '#0e9aa7',
        softOrange: '#f6cd61',
        orangeAccent: '#FF8E00',
        verySoftPink: '#eab9c9',
        veryLightBlue: '#9284ff',
        verySoftCyan: '#b0fdc7',
        moderateBlue: '#3e51b5',
        gray: '#777777',
        veryLightGray: '#fafafa',
        lightGray: '#cfcfcf',
        darkGray: '#333',
        darkGrayAlt: '#a5a5a5',
        darkGrayAlt2: '#424242',
        darkLimeGreen: '#62a25f',
        darkOrange: '#854316',
        verySoftLimeGreen: '#b7fbb2',
        verySoftYellow: '#fef7b7',
        slightlyDesaturatedBlue: '#7aabd5',
        warning: yellow[700],
        error: red[500],
        lightBlue: '#EFF0F6',
        lightGreen: '#00D3A7',
        chart1filled: '#01427b',
        chart1empty: '#d2dfeb',
        chart2filled: '#1295b5',
        chart2empty: '#d4ecf2',
        creditAnalysisEvents: COLORS.primary.main,
        esgAnalysisEvents: '#0095B3',
        fundAnalysisEvents: '#005CA8',
      },
    },
    customPalettes: {
      chartShort: ['#01427B', '#6594BC', '#1295B5', '#FBA11C', '#EF5F11'],
      chartExtended: [
        '#01427B',
        '#3271A5',
        '#6594BC',
        '#1295B5',
        '#40AAC3',
        '#6FC0D3',
        '#FBA11C',
        '#FCC777',
        '#EF5F11',
        '#F5A070',
      ],
    },
    customShadows: [
      '0 3px 4px 1px rgba(155, 155, 155, 0.3)',
      '0 3px 5px 1px rgba(155, 155, 155, 0.3)',
    ],
    breakpoints: {
      values: {
        ...defaultTheme.breakpoints.values,
        lg: 1410,
      },
    },
    typography: {
      fontFamily: '"Inter", sans-serif',
      h6: {
        fontWeight: 400,
      },
    },
    props: {
      MuiTextField: {
        variant: 'outlined',
        margin: 'normal',
      },
      MuiSelect: {
        variant: 'outlined',
      },
    },
    overrides: {
      MuiTooltip: {
        tooltip: {
          fontSize: 12,
        },
      },
      MuiTabs: {
        vertical: {
          borderRight: `1px solid ${grey[200]}`,
          '& $indicator': {
            backgroundColor: 'transparent',
            width: 8,
            right: 10,
            transition: 'none',
            '&:before': {
              display: 'block',
              content: '""',
              width: 0,
              height: 0,
              borderTop: '5px solid transparent',
              borderLeft: `7px solid ${grey[400]}`,
              borderBottom: '5px solid transparent',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
            },
          },
          '& .MuiTab-wrapper': {
            alignItems: 'flex-start',
            paddingLeft: 20,
          },
          selected: {},
        },
        indicator: {},
      },
      MuiTab: {
        root: {
          textTransform: 'none',
          '&$selected': {
            backgroundColor: grey[100],
            color: main,
          },
        },
        wrapper: {},
      },
      MuiAccordion: {
        root: {
          '&$expanded': {
            margin: '1px 0',
          },
        },
        expanded: {},
      },
      MuiCssBaseline: {
        '@global': {
          html: {
            WebkitPrintColorAdjust: 'exact',
            WebkitFilter: useReportPage ? 'opacity(1)' : 'none',
          },
          '#hs-eu-cookie-confirmation': {
            display: useReportPage ? 'none' : 'block',
          },
        },
        '@media print': {
          html: {
            WebkitPrintColorAdjust: 'exact',
            WebkitFilter: useReportPage ? 'opacity(1)' : 'none',
          },
          '#hs-eu-cookie-confirmation': {
            display: useReportPage ? 'none' : 'block',
          },
        },
      },
      MuiDialogActions: {
        root: {
          margin: 0,
          padding: '16px 24px',
        },
      },
      MuiDialogContent: {
        root: {
          paddingTop: '20px !important',
        },
      },
      MUIDataTableSelectCell: {
        headerCell: {
          zIndex: 1,
        },
        fixedLeft: {
          zIndex: 1,
        },
      },
      MUIDataTableHeadCell: {
        fixedHeader: {
          zIndex: 1,
        },
      },
    },
  }),
);
